// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-search-terminal-widget-parent {
  background: var(--theia-sideBar-background);
  position: absolute;
  margin: 0px;
  border: var(--theia-border-width) solid transparent;
  padding: 0px;
  top: 1px;
  right: 19px;

  z-index: 10;
}

.theia-search-terminal-widget-parent .theia-search-elem-box {
  display: flex;
  margin: 0px;
  border: var(--theia-border-width) solid transparent;
  padding: 0px;
  align-items: center;
  color: var(--theia-input-foreground);
  background: var(--theia-input-background);
}

.theia-search-terminal-widget-parent .theia-search-elem-box input {
  margin-left: 5px;
  padding: 0px;
  width: 100px;
  height: 18px;
  color: inherit;
  background-color: inherit;
  border: var(--theia-border-width) solid transparent;
  outline: none;
}

.theia-search-terminal-widget-parent
  .theia-search-elem-box
  .search-elem.codicon {
  height: 16px;
  width: 18px;
}

.theia-search-terminal-widget-parent .search-elem.codicon {
  border: var(--theia-border-width) solid transparent;
  height: 20px;
  width: 20px;
  opacity: 0.7;
  outline: none;
  color: var(--theia-input-foreground);
  padding: 0px;
  margin-left: 3px;
}

.theia-search-terminal-widget-parent .search-elem:hover {
  opacity: 1;
}

.theia-search-terminal-widget-parent .theia-search-elem-box.focused {
  border: var(--theia-border-width) solid var(--theia-focusBorder);
}

.theia-search-terminal-widget-parent
  .theia-search-elem-box
  .search-elem.option-enabled {
  border: var(--theia-border-width) solid var(--theia-inputOption-activeBorder);
  background-color: var(--theia-inputOption-activeBackground);
}

.theia-search-terminal-widget-parent .theia-search-terminal-widget {
  margin: 2px;
  display: flex;
  align-items: center;
  font: var(--theia-content-font-size);
  color: var(--theia-input-foreground);
}

.theia-search-terminal-widget-parent .theia-search-terminal-widget button {
  background-color: transparent;
}

.theia-search-terminal-widget-parent
  .theia-search-terminal-widget
  button:focus {
  border: var(--theia-border-width) var(--theia-focusBorder) solid;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/terminal/src/browser/style/terminal-search.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,mDAAmD;EACnD,YAAY;EACZ,QAAQ;EACR,WAAW;;EAEX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mDAAmD;EACnD,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mDAAmD;EACnD,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gEAAgE;AAClE;;AAEA;;;EAGE,6EAA6E;EAC7E,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,gEAAgE;AAClE","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-search-terminal-widget-parent {\n  background: var(--theia-sideBar-background);\n  position: absolute;\n  margin: 0px;\n  border: var(--theia-border-width) solid transparent;\n  padding: 0px;\n  top: 1px;\n  right: 19px;\n\n  z-index: 10;\n}\n\n.theia-search-terminal-widget-parent .theia-search-elem-box {\n  display: flex;\n  margin: 0px;\n  border: var(--theia-border-width) solid transparent;\n  padding: 0px;\n  align-items: center;\n  color: var(--theia-input-foreground);\n  background: var(--theia-input-background);\n}\n\n.theia-search-terminal-widget-parent .theia-search-elem-box input {\n  margin-left: 5px;\n  padding: 0px;\n  width: 100px;\n  height: 18px;\n  color: inherit;\n  background-color: inherit;\n  border: var(--theia-border-width) solid transparent;\n  outline: none;\n}\n\n.theia-search-terminal-widget-parent\n  .theia-search-elem-box\n  .search-elem.codicon {\n  height: 16px;\n  width: 18px;\n}\n\n.theia-search-terminal-widget-parent .search-elem.codicon {\n  border: var(--theia-border-width) solid transparent;\n  height: 20px;\n  width: 20px;\n  opacity: 0.7;\n  outline: none;\n  color: var(--theia-input-foreground);\n  padding: 0px;\n  margin-left: 3px;\n}\n\n.theia-search-terminal-widget-parent .search-elem:hover {\n  opacity: 1;\n}\n\n.theia-search-terminal-widget-parent .theia-search-elem-box.focused {\n  border: var(--theia-border-width) solid var(--theia-focusBorder);\n}\n\n.theia-search-terminal-widget-parent\n  .theia-search-elem-box\n  .search-elem.option-enabled {\n  border: var(--theia-border-width) solid var(--theia-inputOption-activeBorder);\n  background-color: var(--theia-inputOption-activeBackground);\n}\n\n.theia-search-terminal-widget-parent .theia-search-terminal-widget {\n  margin: 2px;\n  display: flex;\n  align-items: center;\n  font: var(--theia-content-font-size);\n  color: var(--theia-input-foreground);\n}\n\n.theia-search-terminal-widget-parent .theia-search-terminal-widget button {\n  background-color: transparent;\n}\n\n.theia-search-terminal-widget-parent\n  .theia-search-terminal-widget\n  button:focus {\n  border: var(--theia-border-width) var(--theia-focusBorder) solid;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
